import moment from 'moment';
import Tag from '../../../../components/Display/Tag';
import { getImage } from '../../../../utils/imageHelper';
import { getConstant } from '../../../../utils/constants';
import { Calendar } from 'lucide-react';
import styles from "../../cards.module.scss"

function ProgramListItem({ program, handleClickProgram, layout }) {
  return (
    <div
      className={`${styles.projectCard} ${layout === "grid" ? styles.projectCardGrid : ''}`}
      onClick={handleClickProgram}>
      <img
        className={styles.projectImage}
        src={program.image ? program.image.file : getImage('img-ph.png')}
        alt={program.image ? program.image.label : 'Non renseignée'}
      />
      <div className={styles.contentContainer}>
        <div className={styles.topInfo}>
          <p className={styles.title}>{program.title}</p>
          <span className={styles.subtitle}>{program.author}</span>
        </div>
        <div className={styles.tagList}>
          <Tag tag={getConstant('banquetceleste.common.statusTypes', program.status)} rounded />
          <Tag
            tag={{
              label: `${program.upcoming_event_nb} évènements à venir`,
              icon: Calendar,
              bgColor: `${program.upcoming_event_nb ? 'bg-green-500' : 'bg-gray-500'}`
            }}
          />
          {program.properties.map((p) => (
            <Tag
              tag={{
                label: p.label
              }}
              rounded
              key={p.id}
            />
          ))}
        </div>
      </div>
      {/* <p className="text-sm italic">{moment(program.date).format('DD/MM/YYYY')}</p> */}
    </div>
  );
}

export default ProgramListItem;
